import React, { useState } from 'react';
import { InfoIcon, MinimizeIcon, MaximizeIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FloatingLegend: React.FC = () => {
  const [isMinimized, setIsMinimized] = useState(true);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="fixed bottom-4 right-4 bg-white rounded-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)] border border-[#E5E5E5] max-w-xs" data-id="element-194">
      <div className={`p-4 ${isMinimized ? 'pb-3' : ''}`} data-id="element-195">
        <div className="flex items-start justify-between" data-id="element-196">
          <AnimatePresence mode="wait" data-id="element-197">
            {isMinimized ? <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="flex items-center space-x-2" data-id="element-198">
                <InfoIcon className="h-4 w-4 text-[#C00000] flex-shrink-0" data-id="element-199" />
                <span className="text-sm text-[#404040]" data-id="element-200">95% Confidence</span>
              </motion.div> : <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="flex items-start space-x-3" data-id="element-201">
                <InfoIcon className="h-5 w-5 text-[#C00000] flex-shrink-0 mt-0.5" data-id="element-202" />
                <div data-id="element-203">
                  <h4 className="font-medium text-[#101010] text-sm" data-id="element-204">
                    95% Confidence Level
                  </h4>
                  <p className="text-xs text-[#737373] mt-1" data-id="element-205">
                    Results at this level indicate very strong statistical
                    confidence in the findings.
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
          <button onClick={() => setIsMinimized(!isMinimized)} className="ml-3 p-1 hover:bg-gray-100 rounded-full transition-colors" aria-label={isMinimized ? 'Show more details' : 'Show less details'} data-id="element-206">
            {isMinimized ? <MaximizeIcon className="h-4 w-4 text-[#737373]" data-id="element-207" /> : <MinimizeIcon className="h-4 w-4 text-[#737373]" data-id="element-208" />}
          </button>
        </div>
      </div>
    </motion.div>;
};